import React from "react";
import ServicesList from "../reusables/ServicesList";

const ServicesBody = () => {
  return (
    <section className="section section-spacing-100 no-padding-bottom">
      <div className="container">
        <div className="large">
          <div className="section-content">
            <div className="section-head services-brief width-600 margin-auto">
              <p>
                NEGASH CONSTRUCTION COMPANY is proud to be recognized as a
                leading construction, setting trends in construction methods,
                safety, quality, and client satisfaction.{" "}
              </p>
              <p>
                The reliability and professionalism of our entire team means
                that we deliver the highest quality construction services and
                that our clients are treated with respect and consideration
                every step of the way.{" "}
              </p>
              <p>
                We do not consider a project a success unless our client is
                completely satisfied. It is this attitude that has led to repeat
                business and high-quality work here in South Sudan
              </p>
              <p>
                Our Construction Company is large enough to offer the range of
                services needed, but small enough to deliver projects with
                personal attention to our clients’ quality standards, schedules,
                and budgets.{" "}
              </p>
              <p>
                Our skilled teams take pride in guiding a project from
                conception to successful completion. Our experts are with
                clients from the very beginning to listen to their needs and
                develop a clear and shared vision for a project. Then we
                collaborate with talented architects, engineers, and
                subcontractors to bring that vision to life.{" "}
              </p>
              <p>
                This interactive approach ensures quality workmanship and
                attention to detail every step of the way and a finished
                structure you can be proud of. We get it and we get it done. No
                matter which of these construction services you choose, NEGASH
                CONSTRUCTION COMPANY is your partner in the process:
              </p>
            </div>
            <div className="section-body section-spacing-20">
              <ServicesList />
            </div>
            <div className="section-footer buttons-container flex justify-center section-spacing-20 no-padding-bottom">
              <a
                href="https://form.jotform.com/negashltd/lets-talk"
                target="_blank"
                rel="noopener noreferrer"
                className="button sub-cta boldTitle dark capitalize"
              >
                Let's talk about your project &#8594;
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesBody;

{
  /*




<div className="services-container width-600 margin-auto">
              <ul>
                <li>
                  <h3>1. HDPE welding</h3>
                  <p>
                    At JMSTONE, we pride ourselves in delivering top-quality
                    HDPE welding that meet the highest standard of performance
                    and durability in line with the industry standards. We offer
                    exceptional HDPE welding service, ensuring that every seam
                    is precision-crafted to last.
                  </p>
                  <p>
                    Our expert welders use latest welding techniques, utilizing
                    state-of-the-art equipment to create impermeable seams that
                    comply with industry standards. We employ advanced methods
                    such as:
                  </p>
                  <ul>
                    <li>• Fusion Welding for HDPE Liner </li>
                    <li>• Extrusion welding for HDPE repairs </li>
                    <li>
                      • Hot gas welding for tacking and Reinforced Vinyl Tank
                      Construction{" "}
                    </li>
                    <li>• Welding and assembling inflatable HDPE tanks </li>
                    <li>• Butt fusion 1 inch to 12.40 inches </li>
                  </ul>
                  <p>
                    To ensure that all welds meet or exceed industry standards,
                    several testing methods are employed and Include:
                    Destructive Testing, Non-Destructive Testing, Visual
                    Inspection and Hydrostatic Testing.{" "}
                  </p>
                </li>
                <li>
                  <h3>2. Earth Works </h3>
                  <p>
                    WE also undertake the associated Geosynthetics and HDPE pipe
                    installation earthworks.
                  </p>
                </li>
                <li>
                  <h3>3. NDT Welding Inspection </h3>
                  <p>
                    Non-Destructive Testing (NDT) welding inspection services
                    are crucial for ensuring the quality and safety of welded
                    structures without causing damage to the components being
                    inspected. The methods JMSTONE uses in HDPE welding
                    inspection include: 1) Visual Inspection, 2) Air Pressure
                    Testing, 3) Vacuum Air Pressure Testing, and 4) Air Spark
                    Testing.
                  </p>
                  <p>
                    These methods help ensure that welds meet industry standards
                    and specifications, providing confidence in the integrity
                    and safety of the welded structures.
                  </p>
                </li>
                <li>
                  <h3>4. Tent/tarpaulin making and repairing </h3>
                  <p>
                    JMSTONE LOGISTICS has extended its range of services by
                    offering specialized tent and tarpaulin making services. We
                    also provide repair services to fix holes and tears, seam
                    repairs, zipper replacements and leak proofing.
                  </p>
                </li>
                <li>
                  <h3>5. Repair and maintenance </h3>
                  <p>
                    We understand that even the most durable geomembrane liners
                    require periodic maintenance and occasional repairs to
                    ensure optimal performance and extend their lifespan.
                  </p>
                  <p>
                    That’s why we offer expert repair and maintenance services
                    to our clients, designed to safeguard your liner, and the
                    environment from any possible leaks.
                  </p>
                  <p>
                    Our team of skilled technicians and welders are equipped to
                    detect and repair any damage, from minor punctures to
                    extensive tears.
                  </p>
                </li>
              </ul>
            </div>








*/
}
